import VinData from '../../types/VinData';

const useVinDecoder = () => {
  return async (vin: string) => {
    const result: VinData = await fetch(
      `${process.env.CLIENT_SERVER_URL}/api/vin-decoder?vin=${vin}`
    ).then((res) => res.json());

    return result;
  };
};

export default useVinDecoder;
